import { render, staticRenderFns } from "./registrationLayout.vue?vue&type=template&id=45494477&scoped=true"
import script from "./registrationLayout.vue?vue&type=script&lang=js"
export * from "./registrationLayout.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45494477",
  null
  
)

export default component.exports